import { Link } from 'react-router-dom';
import { Calculator, ArrowRight } from 'lucide-react';

import ViewRecentEstimateForNavigation from './ViewRecentEstimateForNavigation';
import { Loading } from '@/app/ui/loading';
import { Error } from '@/app/ui/error';
import { useRecentEstimates } from '@/data/recentEstimate';

// Flyout panel for the navigation rail's Estimate item: a header, the recent
// estimate list (or a loading/empty state) and a "view all" footer. Mounted
// lazily by the flyout wrapper, so the SWR request only fires once the popover
// is opened.
const ListRecentEstimatesForNavigation = () => {
  const recentEstimates = useRecentEstimates();

  let body;
  if (recentEstimates.error) {
    body = (
      <div className="p-3">
        <Error message="Couldn't load recent estimates." />
      </div>
    );
  } else if (!recentEstimates.data) {
    body = <Loading height={120} />;
  } else if (recentEstimates.data.query.length === 0) {
    body = (
      <div data-testid="nav-recent-estimates-empty" className="px-4 py-8 text-center text-sm text-muted-foreground">
        No recent estimates
      </div>
    );
  } else {
    body = (
      <div className="p-1.5">
        {recentEstimates.data.query.map((uid) => (
          <ViewRecentEstimateForNavigation key={uid} uid={uid} />
        ))}
      </div>
    );
  }

  return (
    <div data-testid="nav-recent-estimates" className="w-80 overflow-hidden rounded-2xl border bg-popover text-popover-foreground shadow-lg">
      <div className="flex items-center justify-between border-b px-4 py-3">
        <div className="flex items-center gap-2 text-sm font-semibold">
          <Calculator className="size-4 text-muted-foreground" />
          Estimates
        </div>
        <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Recent</span>
      </div>
      {body}
      <Link
        to="/estimate"
        data-testid="nav-recent-estimates-view-all"
        className="flex items-center justify-between border-t px-4 py-3 text-sm font-semibold text-primary hover:bg-accent transition-colors"
      >
        View All Estimates
        <ArrowRight className="size-4" />
      </Link>
    </div>
  );
};

export default ListRecentEstimatesForNavigation;
